<div class="modal-backdrop-custom">
  <div class="modal-box" [class]="size">
    <div class="modal-header-custom">
      <div class="modal-header-text">
        <ng-content select="[icon]"></ng-content>
        <h5>{{ title }}</h5>
      </div>
      <button type="button" class="close-btn" [disabled]="closeDisabled" (click)="close()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <div class="modal-body-custom">
      <ng-content></ng-content>
    </div>
    <div class="modal-footer-custom">
      <ng-content select="[footer]"></ng-content>
    </div>
  </div>
</div>
